<template>
  <div>
    <FormSelect
      :value="value"
      @input="updateValue"
      :optionsPromise="accountLocationPromise"
      :field="field"
      :placeholder="placeholder"
      :note="note"
      v-show="showLocationDropdown"
    />
    <FormStaticLabel v-show="!showLocationDropdown">
      <LabelAccountLocationBadge :accountLocationId="value" />
    </FormStaticLabel>
  </div>
</template>



<script>
import _ from 'lodash'

export default {
  name: 'AccountLocationSelect',
  model: {
    event: 'update'
  },
  props: {
    value: [Number, String],
    field: String,
    placeholder: String,
    note: String,
    allowNone: Boolean,
    activeOnly: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loadingList: false,
      internalList: [],
      accountLocationPromise: this.getAccountLocationPromise(),
    }
  },
  computed: {
    showLocationDropdown() {
      // If we're allowing none, always show the dropdown
      if(this.allowNone)
        return true

      // If loading, show the dropdown. It'll show the loading state
      if(this.loadingList)
        return true

      // If we've got exactly 1 location, display the static label
      if(!this.loadingList && this.internalList.length == 1)      
        return false

      return true
    },
  },
  methods: {
    getAccountLocationPromise() {
      return new Promise((resolve, reject) => {
        this.loadingList = true

        return this.$apiService.adminService.getAccountLocations()
        .then(response => {
          let accList = response.data

          if(this.activeOnly)
            accList = accList.filter(location => location.isActive)

          var accountOptions = accList.map((location, index) => {
            return { name: `${location.name} - ${location.formattedAddress}`, value: location.id, isDefault: index == 0 }
          })

          this.internalList = accountOptions

          return resolve(_.concat(_.compact(this.allowNone ? [{ value: null, name: 'None' }] : null), accountOptions))
        })
        .catch(err => {
          return reject(err)
        })
        .finally(() => {
          this.loadingList = false
        })
      })
    },
    updateValue(value) {
      this.$emit('update', value)
    }

  }
}
</script>